const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = [{
    dataIndex: 0,
    id: '3pool',
    name: '3pool',
    lpTokenInfo: {
        name: '3poolCurve',
        symbol: '3poolCrv',
    },
    assets: 'DAI+USDC+USDT',
    coins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        lpToken: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        gauge: '0x7f90122BF0700F9E7e1F688fe926940E8839F353',
    },
    gaugeVersion: 3, // No CRV rewards
    hasNoCRVRewards: true,
}, {
    dataIndex: 2,
    id: 'wsteth',
    name: 'wstETH',
    lpTokenInfo: {
        name: 'wstETHCurve',
        symbol: 'wstETHCrv',
    },
    coingeckoInfo: {
        id: 'wsteth',
        symbol: 'wstETH',
        referenceAssetId: 'wrapped-steth',
    },
    assets: 'ETH+wstETH',
    coins: [
        coins.eth,
        coins.wsteth,
    ],
    addresses: {
        swap: '0xB90B9B1F91a01Ea22A182CD84C1E22222e39B415',
        lpToken: '0xEfDE221f306152971D8e9f181bFe998447975810',
        gauge: '0xD53cCBfED6577d8dc82987e766e75E3cb73a8563',
    },
    gaugeVersion: 3, // No CRV rewards
    referenceAsset: REFERENCE_ASSETS.ETH,
    hasNoCRVRewards: true,
}];
